var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52632 1.26316C2.52632 1.96083 1.96087 2.52632 1.26316 2.52632C0.565446 2.52632 0 1.96083 0 1.26316C0 0.565485 0.565446 0 1.26316 0C1.96087 0 2.52632 0.565485 2.52632 1.26316Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52632 7.57895C2.52632 8.27663 1.96087 8.84211 1.26316 8.84211C0.565446 8.84211 0 8.27663 0 7.57895C0 6.88128 0.565446 6.3158 1.26316 6.3158C1.96087 6.3158 2.52632 6.88128 2.52632 7.57895Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52632 13.8947C2.52632 14.5924 1.96087 15.1579 1.26316 15.1579C0.565446 15.1579 0 14.5924 0 13.8947C0 13.1971 0.565446 12.6316 1.26316 12.6316C1.96087 12.6316 2.52632 13.1971 2.52632 13.8947Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79481 0H22.9948C23.5499 0 24.0001 0.659057 24.0001 1.1935V1.33282C24.0001 1.99187 23.5501 2.52632 22.9948 2.52632H4.79481C4.2397 2.52632 3.78955 1.86726 3.78955 1.33282V1.1935C3.78955 0.534443 4.23952 0 4.79481 0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79481 6.3158H22.9948C23.5499 6.3158 24.0001 6.97485 24.0001 7.5093V7.64861C24.0001 8.30767 23.5501 8.84211 22.9948 8.84211H4.79481C4.2397 8.84211 3.78955 8.18305 3.78955 7.64861V7.5093C3.78955 6.85024 4.23952 6.3158 4.79481 6.3158Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79481 12.6316H22.9948C23.5499 12.6316 24.0001 13.2906 24.0001 13.8251V13.9644C24.0001 14.6235 23.5501 15.1579 22.9948 15.1579H4.79481C4.2397 15.1579 3.78955 14.4989 3.78955 13.9644V13.8251C3.78955 13.166 4.23952 12.6316 4.79481 12.6316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListControl);
export default __webpack_public_path__ + "static/media/listControl.113cfc04285adab113a03299718bf1f3.svg";
export { ForwardRef as ReactComponent };